import { Component, OnInit } from '@angular/core';
import { Order, OrderRow } from 'gung-standard';
import { JeevesOrderDetailsComponent } from 'gung-standard-jeeves';
import { first } from 'rxjs';

@Component({
    selector: 'ref-capstone-order-details',
    templateUrl: './capstone-order-details.component.html',
    styleUrls: ['./capstone-order-details.component.scss'],
    standalone: false
})
export class CapstoneOrderDetailsComponent extends JeevesOrderDetailsComponent implements OnInit {
  isAdminOrSales: boolean = false;
  
  ngOnInit() {
    super.ngOnInit();
    this.authService.getRoles().pipe(first()).subscribe(roles => {
      this.isAdminOrSales = roles.includes('ADMIN') || roles.includes('SALES');
    });
  }

  protected mapOrder(order: Order): Order {
    order = this.getAllOrderMargin(order);

    for (let row of order.rows) {
      row = this.getRowMargin(row);
    }

    return order;
  }

  protected getAllOrderMargin(order: Order): Order {
    const ohfakttb: number = Number(order.extra.oh.ohfakttb) || 0;
    const ohordkostnad: number = Number(order.extra.oh.ohordkostnad) || 0;
    const ohordsum: number = Number(order.extra.oh.ohordsum) || 0;

    const divide = ohordkostnad/ohordsum;
    // Check if it's a division by 0, if it is and there is no margin, set marginPercentage as 0% else make percentage negative
    // If division is not by 0 then use normal value to calculate normal percentage
    const marginPercentage = ((!isFinite(divide) ? (ohfakttb !== 0 ? 2 : 1) : divide) - 1) * (-100);

    order.extra._gungMargin = ohfakttb;
    order.extra._gungMarginPercentage = marginPercentage;

    return order;
  }

  protected getRowMargin(row: OrderRow): OrderRow {
    const netPrice: number = Number(row.extra?.orp?.vbordradsumnetto);
    const cost: number = Number(row.extra?.orp?.vbartkalkbersum);
    
    const margin: number = netPrice - cost;
    const marginPercentage: number = (margin / netPrice) * 100;
    
    row.extra._gungMargin = margin;
    row.extra._gungMarginPercentage = !isFinite(marginPercentage) ? -100 : marginPercentage;

    return row;
  }
}
